export const LOGIN = '/login'
export const PRODUCT = '/product'
export const MATERAIAL = '/material'
export const USER = '/userAdmin'
export const APPUSER = '/user'
export const BARCODE = '/barcode'
export const HERO = '/hero'
export const MAP = '/map'
export const HEROLINK = '/heroLink'
export const HERONEWS = '/hero-news-item'
export const NEWS = '/newsItem'
export const BANNERS = '/bannersItem'
export const DOCUMENTS = '/document'
export const HEROPROMOTE = '/heroPromote'
export const BRAND = '/brand'
export const BRAND_NEWS = '/brand-news'
export const BRAND_COVER = '/brand-cover'
export const BRAND_ACTIVITY = '/brand-activity'
export const BIN = '/bin'
export const PRESET = '/preset'
export const STEP = '/step'
export const PRODUCT_FEATURE = '/product-feature'
export const LOCATION = '/location'
export const USER_ANNOUNCEMENT = '/app-user-announcement'
export const APP_VERSION = '/app-version'
export const REPORT_PROBLEM = '/problem-report'
export const NOTIFICATION = '/notification'
export const REWARD = '/reward'
export const EQUIPMENT = '/equipment'



// WEBPACK FOOTER //
// ./src/api/EndPoints.js